import { api_fetch_throws } from "./client.tsx"

export type WizardOutcomeCacheKindApi = "ledger_wiz" | "split_wiz"

/** Matches GET /accounting/wizard/outcome-cache — `outcome` is the same JSON shape as wizard run responses. */
export interface WizardOutcomeCacheGetResponse {
  saved_at: string | null
  outcome: unknown | null
}

export async function fetch_wizard_outcome_cache(
  deduction_id: string,
  kind: WizardOutcomeCacheKindApi,
): Promise<WizardOutcomeCacheGetResponse> {
  return api_fetch_throws<WizardOutcomeCacheGetResponse>("/accounting/wizard/outcome-cache", {
    params: { deduction_id, kind },
  })
}
